import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import 'dayjs/locale/fr'
import 'dayjs/locale/en'

// Enable custom parse format plugin
dayjs.extend(customParseFormat)

// Date format constants for different locales
export const FORMAT_DDMMYYYY = 'DD/MM/YYYY'
export const FORMAT_MMDDYYYY = 'MM/DD/YYYY'
export const FORMAT_ISO = 'YYYY-MM-DD'

export function formatDate(date: string | Date, format?: string): string {
    return dayjs(date).format(format || FORMAT_DDMMYYYY)
}

/**
 * Gets the appropriate date format based on the current locale
 * @param locale - The current locale (e.g., 'en', 'fr')
 * @returns The date format string for the given locale
 */
export function getDateFormatForLocale(locale: string): string {
    switch (locale) {
        case 'en':
        case 'en-US':
            return FORMAT_MMDDYYYY
        case 'fr':
        case 'fr-FR':
        default:
            return FORMAT_DDMMYYYY
    }
}

/**
 * Formats a date for display based on the current locale
 * @param date - The date to format
 * @param locale - The current locale
 * @returns The formatted date string
 */
export function formatDateForLocale(date: string | Date, locale: string): string {
    const format = getDateFormatForLocale(locale)
    return dayjs(date).format(format)
}

/**
 * Converts a date from locale format to ISO format for form submission
 * @param dateString - Date string in locale format
 * @param locale - The locale format used
 * @returns ISO formatted date string
 */
export function convertToISODate(dateString: string, locale: string): string {
    const format = getDateFormatForLocale(locale)
    return dayjs(dateString, format).format(FORMAT_ISO)
}

/**
 * Converts a date from ISO format to locale format for display
 * @param isoDateString - Date string in ISO format
 * @param locale - The target locale format
 * @returns Date string in locale format
 */
export function convertFromISODate(isoDateString: string, locale: string): string {
    return formatDateForLocale(isoDateString, locale)
}
